/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Select_Marker_LabelInputs */



/**
* | output |
* | --- |
* | "Select marker" |
*
* @param {Markers_Select_Marker_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_select_marker_label = /** @type {((inputs?: Markers_Select_Marker_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Select_Marker_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner le marqueur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Marker auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona marcatore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите маркер")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar marcador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择标记")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マーカーを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मार्कर का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o marcador")
	return /** @type {LocalizedString} */ ("Select marker")
});